export default __webpack_public_path__ + "static/media/access.024c0c88.png";